import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Receiver from '../components/Receiver/ReceiverPage.vue'
import Admin from '../components/admin/admin.vue'
import authservice from '../services/auth.service'
import ErrorComponent from '../components/Receiver/ErrorComponent.vue'
import UserGroup from '../components/UserGroup/ManageUserGroup.vue'
import NewUserGroup from '../components/NewUserGroup/NewUserGroup.vue'
import EditUserGroup from '../components/EditUserGroup/EditUserGroup.vue'

import {api_service} from '../main'
const CALLBACK_PATH = '/implicit/callback'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    beforeEnter: guardMyroute
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin
  },
  {
    path: '/user-group',
    name: 'UserGroup',
    component: UserGroup,
    children: [
      {
        path: 'edit-user-group',
        name: 'EditUserGroup',
        component: EditUserGroup
      },
      {
        path: 'new-user-group',
        name: 'NewUserGroup',
        component: NewUserGroup
      },
    ]
  },
  {
    path: '/receiver/:id',
    name: 'Receiver',
    component: Receiver
  },
  {
    path: '/error',
    name: 'Error',
    component: ErrorComponent
  }
]

function logout (){
  const callbackUrl = window.location.href
  const match = callbackUrl.match('id_token=([^&]*)')
  if(match){
    window.localStorage.curURL = process.env.VUE_APP_redirect_uri
  }
  window.sessionStorage.clear();
  window.localStorage.removeItem ('accesstoken');
  window.localStorage.removeItem ('idToken');
  const loggingout = "api/logout/";
  api_service.getData("post", `${loggingout}`, {}, {}, null, {})
    .then(data => {
      window.localStorage.removeItem ('accesstoken');
      window.localStorage.removeItem ('idToken');
    })
}
async function guardMyroute (to, from, next) {
  var isAuthenticated = await authservice.authenticate()
  // this is just an example. You will have to find a better or centralised way to handle you localstorage data handling
  window.onbeforeunload = () => {
    logout();
  };
  if (isAuthenticated) {
    next()// allow to enter route
  }
  else {
    next('/Login')
  }
}

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
